import { forwardRef } from 'react';
import type { ButtonHTMLAttributes } from 'react';
import type { LucideIcon } from 'lucide-react';

interface PesageButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'ghost' | 'danger';
  size?: 'sm' | 'md';
  icon?: LucideIcon;
}

const variantStyles = {
  primary: 'bg-pesage-green text-white hover:bg-emerald-600',
  ghost: 'border border-pesage-border text-pesage-secondary hover:text-pesage-primary hover:bg-pesage-hover',
  danger: 'border border-pesage-red text-pesage-red hover:bg-pesage-red-bg',
};

const sizeStyles = {
  sm: 'px-3 py-1.5 text-xs',
  md: 'px-4 py-2 text-sm',
};

export const PesageButton = forwardRef<HTMLButtonElement, PesageButtonProps>(function PesageButton({
  variant = 'primary',
  size = 'md',
  icon: Icon,
  className = '',
  children,
  ...props
}, ref) {
  return (
    <button
      ref={ref}
      className={`inline-flex items-center justify-center gap-2 rounded-md font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-50 ${variantStyles[variant]} ${sizeStyles[size]} ${className}`.trim()}
      {...props}
    >
      {Icon && <Icon className="h-4 w-4" />}
      {children}
    </button>
  );
});
